<ion-row class="toggle-container ion-justify-content-center">
	@for (article of optionGroup.articles; track article) {
		<div (click)="select(article)" [class.selected]="isSelected(article)" class="flex-1 pointer">
			<span class="font-14">
				{{ article.name.de }}
				@if (getPrice(article, ot.STANDARD, preorderType) > 0) {
					+{{ numberToCurrency(getPrice(article, ot.STANDARD, preorderType), repository._venue.currency) }}
				}
			</span>
		</div>
	}
</ion-row>
